// extracted by mini-css-extract-plugin
export var aboveInput = "_o7-0";
export var actionButton = "_o7-5";
export var actionButtonContainer = "_o7-1";
export var actionIcon = "_o7-6";
export var aiInfoContainer = "_o7-2";
export var attachmentWrapper = "_o7-7";
export var bold = "_o7-3";
export var checkIcon = "_o7-8";
export var clickingRecipientBar = "_o7-11";
export var commentThreadSwitch = "_o7-a";
export var draftImage = "_o7-b";
export var draftImageContainer = "_o7-c";
export var draftImages = "_o7-e";
export var editButton = "_o7-g";
export var editor = "_o7-f";
export var editorContainer = "_o7-y";
export var editorErrorTooltipWrapper = "_o7-9";
export var headerDivider = "_o7-h";
export var icon = "_o7-i";
export var info = "_o7-j";
export var internal = "_o7-n";
export var internalDivider = "_o7-k";
export var internalMessage = "_o7-l";
export var messageInputCard = "_o7-m";
export var messageInputForm = "_o7-o";
export var messageInputFormInternal = "_o7-p";
export var options = "_o7-q";
export var publicMessageCustomer = "_o7-s";
export var publicMessageMerchant = "_o7-r";
export var removeImageButton = "_o7-d";
export var replyButtons = "_o7-t";
export var showSignatureButton = "_o7-u";
export var spinner = "_o7-v";
export var verticalButtonDivider = "_o7-4";
export var visibilitySelector = "_o7-w";
export var warning = "_o7-x";
export var wrappingText = "_o7-z";
export var writingInternalNoteTopBorder = "_o7-10";